import React from 'react';
import PropTypes from 'prop-types';

/**
 * FullPageLoader Component
 * 
 * Shows a full-page loading spinner while the application is busy.
 */
const FullPageLoader = ({ isLoading }) => {
    if (!isLoading) return null;

    return (
        <div
            className="page-loader position-fixed w-100 h-100 justify-content-center align-items-center"
            style={{
                zIndex: 999999,
                display: isLoading ? 'flex' : 'none',  // Controla visibilidad según isLoading
                backgroundColor: 'rgb(130 130 130 / 53%)',
                top: 0,
                left: 0,
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh', // Asegura que el loader cubra toda la pantalla
                width: '100vw',
            }}
            id="pageLoader"
        >
            <div
                className="spinner-border"
                style={{
                    width: '80px',
                    height: '80px',
                    borderWidth: '8px',
                    borderTopColor: '#00ff08', // Color verde en la parte superior
                    borderRightColor: '#00ff08', // Color verde a la derecha
                    borderBottomColor: 'transparent', // Transparente en la parte inferior
                    borderLeftColor: 'transparent', // Transparente a la izquierda
                    animation: 'spin 1.5s linear infinite', // Animación de rotación
                    boxShadow: '0 0 20px rgba(0, 255, 8, 0.5)' // Sombra ligera
                }}
            ></div>
        </div>
    );
};

FullPageLoader.propTypes = {
    isLoading: PropTypes.bool.isRequired,
};

export default FullPageLoader;
